import { useTranslation } from "react-i18next"

import Table, { Body, Header, HeaderCell } from "@/components/Table/Table"
import type { Survey } from "@/types/surveyTypes"

import SurveysItem from "./SurveysItem"

export default function SurveysShow({ surveys }: { surveys: Array<Survey> }) {
  const { t } = useTranslation()
  return (
    <div>
      <Table>
        <Header>
          <HeaderCell>{t("surveysPage.table.no")}</HeaderCell>
          <HeaderCell>{t("surveysPage.table.title")}</HeaderCell>
          <HeaderCell>{t("surveysPage.table.description")}</HeaderCell>
          <HeaderCell></HeaderCell>
        </Header>
        <Body>
          {surveys?.sort(sortUnansweredSurveysToTop).map((ele, index) => {
            return <SurveysItem from={index + 1} key={ele.id} ele={ele} />
          })}
        </Body>
      </Table>
    </div>
  )
}

function sortUnansweredSurveysToTop(a: Survey, b: Survey) {
  if (!a.user_answers && b.user_answers) return -1
  if (a.user_answers && !b.user_answers) return 1
  return 0
}
